// Constants
import { ONE_SECOND_MILIS } from 'containers/contract/views/otp/constants/contract-otp.constants';
import {
  MAX_ATTEMPS_WARNING,
  SESSION_TIMEOUT_END,
  SESSION_TIMEOUT_HALF,
} from './constants/session-expire.handlers.constants';
import { ONBOARDING_INIT_LOCAL_STORAGE } from 'constants/app.constants';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Translations
import {
  SESSION_ALMOST_TIMEOUT,
  SESSION_HALF_TIMEOUT,
} from '../translations/session-expire.translations';
// Types
import {
  SessionExpireHandlersBuilderType,
  SessionExpireHandlersReturnType,
  SessionWarningHandlerType,
} from './types/session-expire.handlers.type';

const sessionWarningHandler = async ({
  formatMessage,
  timeoutRef,
  timeout,
  setError,
  setSessionWarningMessage,
}: SessionWarningHandlerType): Promise<void> => {
  const remaining = Math.floor(
    (new Date(timeout).getTime() - new Date().getTime()) / ONE_SECOND_MILIS
  );

  if (remaining > 0) {
    const isWarningDelta = (threshold: number): boolean =>
      remaining - threshold <= MAX_ATTEMPS_WARNING && remaining - threshold > 0;

    if (isWarningDelta(SESSION_TIMEOUT_HALF)) {
      setSessionWarningMessage(formatMessage({ id: SESSION_HALF_TIMEOUT }));
    } else if (isWarningDelta(SESSION_TIMEOUT_END)) {
      setSessionWarningMessage(formatMessage({ id: SESSION_ALMOST_TIMEOUT }));
    } else {
      setSessionWarningMessage('');
    }
  } else {
    clearInterval(timeoutRef.current);
    setError(AppErrorEnumeration.DECLINED_ONBOARDING);
  }
};

const startSessionTimeoutHandler = ({
  formatMessage,
  timeoutRef,
  setError,
  setSessionWarningMessage,
}: SessionExpireHandlersBuilderType): void => {
  const init = new Date(localStorage.getItem(ONBOARDING_INIT_LOCAL_STORAGE) || '');
  init.setMinutes(init.getMinutes() + 29);

  const timeout = init.toString();

  if (timeout && !timeoutRef.current) {
    timeoutRef.current = setInterval(
      () => {
        sessionWarningHandler({
          formatMessage,
          timeoutRef,
          timeout,
          setError,
          setSessionWarningMessage,
        });
      },
      ONE_SECOND_MILIS,
      []
    );
  }
};

const closeWarningMessageHandler = ({
  setSessionWarningMessage,
}: Pick<SessionExpireHandlersBuilderType, 'setSessionWarningMessage'>): void => {
  setSessionWarningMessage('');
};

const SessionExpireHandlers = ({
  setSessionWarningMessage,
  ...props
}: SessionExpireHandlersBuilderType): SessionExpireHandlersReturnType => ({
  handleStartSessionTimeout: () =>
    startSessionTimeoutHandler({ setSessionWarningMessage, ...props }),
  handleCloseWarningMessage: () => closeWarningMessageHandler({ setSessionWarningMessage }),
});

export { SessionExpireHandlers };
